import { DEFAULT_GROUP } from '../../../config/constants';

/**
 * Parse the `selectedGroup` string from the store into a numeric group id.
 *
 * Centralizes the `parseInt(selectedGroup) || 6` pattern that previously
 * appeared in 4 places across the parent-v2 portal (HomePage, VoortgangPage,
 * useGrowthData, ModuleDetailDrawer). Silent fallback to {@link DEFAULT_GROUP}
 * when the input cannot be parsed.
 *
 * Audit ref: PARENT_PORTAL_UX_AUDIT_2026 §18.4 C-P-NEW-1 / F-RUN-NEW-7.
 */
export function parseGroupNum(selectedGroup: string | undefined | null): number {
  if (!selectedGroup) return DEFAULT_GROUP;
  const parsed = parseInt(selectedGroup, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : DEFAULT_GROUP;
}